import { defineMessages, useIntl } from 'react-intl';
import useDocumentTitle from '@rehooks/document-title';
import commonMessage from 'messages/common';

const messages = defineMessages({
  documentTitle: {
    id: 'common.documentTitle',
    defaultMessage: '{title} - 퀀타스틱',
    description: '{title} - quantastic'
  }
});

function useDocTitle(title?: string, hasCompanyName: boolean = true) {
  const intl = useIntl();
  let titleMessage = intl.formatMessage(commonMessage.quantastic);
  if (title) {
    if (hasCompanyName) {
      titleMessage = intl.formatMessage(messages.documentTitle, {
        title: title
      });
    } else {
      titleMessage = title;
    }
  }

  useDocumentTitle(titleMessage);
}

export default useDocTitle;
